/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data, shop) {
  const [seeMore, setSeeMore] = useState(false)
  const [foods, setFoods] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setFoods(data.data)
  }, [data])

  return (
    <>
    <div style={seeMore ? { } : { maxHeight: '330px', overflow: 'hidden' }}>
      <table className='table' style={seeMore ? {  } : { overflow: 'hidden' }}>
        <thead>
          <tr>
            <th>نام غذا یا نوشیدنی</th>
            <th>تعداد فروش</th>
            <th>گرید</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {foods ? foods.map((item, index) => 
              <tr key={index}>
                <td>{item[0]}</td>
                <td>{item[1]}</td>
                <td style={index === 0 || index === 1 || index === 2 ? { color : '#198524' } : {}}>{index === 0 || index === 1 || index === 2 ? 'Top' : '-'}</td>
                <td>
                  <button onClick={() => navigate(`/foods`)}>مشاهده</button>
                </td>
              </tr>) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </div>
    <div className='tableVisibleBtn' style={seeMore ? { display: 'none' } : { }}>
      <span onClick={() => setSeeMore(true)}>
        مشاهده بیشتر 
      </span>
    </div>
    </>
  );
}
